/**
 * Quão velho está o dado publicado — funções puras.
 *
 * O ciclo dos rios roda de hora em hora, e não a cada 15 min como a chuva:
 * o nível de um rio amazônico muda de 5 a 30 cm por DIA, e buscar 154
 * estações a cada ciclo seriam ~15 mil requisições diárias a um serviço
 * público para um dado que não mudou.
 */

/** Cadência nominal do passo `rios.mjs` dentro do workflow da chuva. */
export const CADENCIA_MIN = 60;

/** Três ciclos perdidos: deixa de ser atraso normal e vira problema. */
export const ATRASO_AVISO_MIN = CADENCIA_MIN * 3;

/** Um dia de silêncio: a cheia ou a vazante já andou o bastante para enganar. */
export const ATRASO_GRAVE_MIN = 24 * 60;

export type Frescor = 'ok' | 'atrasado' | 'velho' | 'desconhecido';

export function atrasoMin(gerado: number | null, agora: number = Date.now()): number | null {
  if (gerado === null || !Number.isFinite(gerado)) return null;
  // Relógio do visitante adiantado não deve virar "atraso negativo".
  return Math.max(0, (agora - gerado) / 60_000);
}

export function frescorDe(gerado: number | null, agora: number = Date.now()): Frescor {
  const min = atrasoMin(gerado, agora);
  if (min === null) return 'desconhecido';
  if (min >= ATRASO_GRAVE_MIN) return 'velho';
  if (min >= ATRASO_AVISO_MIN) return 'atrasado';
  return 'ok';
}

export function avisoDeFrescor(gerado: number | null, agora: number = Date.now()): string | null {
  const f = frescorDe(gerado, agora);
  if (f === 'ok' || f === 'desconhecido') return null;
  const min = atrasoMin(gerado, agora)!;
  const quanto = min >= 120 ? `${Math.floor(min / 60)} h` : `${Math.round(min)} min`;
  return f === 'velho'
    ? `Cotas paradas há ${quanto}. O que está no mapa não é o rio de agora.`
    : `Cotas sem atualizar há ${quanto} — o normal é a cada ${CADENCIA_MIN} min.`;
}
